var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6521 48.948H3.81709C1.70892 48.948 0 47.239 0 45.1308V4.29589C0 2.18793 1.70892 0.479004 3.81709 0.479004H44.6521C46.7604 0.479004 48.469 2.18793 48.469 4.29589V45.1308C48.469 47.239 46.7604 48.948 44.6521 48.948Z",
    fill: "#1F2B2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8807 33.8753L14.9405 25.7431L18.8866 21.7018L22.8807 25.7923L26.875 21.7018L30.8209 25.7431L22.8807 33.8753ZM42.7558 13.5203L38.8096 9.479L34.8156 13.5696L30.8209 9.479L26.8269 13.5696L22.8807 9.52828L7 25.7923L22.8807 42.0565L38.7615 25.7923L34.7672 21.7018L42.7558 13.5203Z",
    fill: "#16D4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeon);
export default __webpack_public_path__ + "static/media/neon.be96d8b12ffcf6ac8608dc742eb81409.svg";
export { ForwardRef as ReactComponent };